import Hls from 'hls.js';
import { createHlsStreamHandler } from '../../../MediaController';
import { isHlsStreamValid } from '../../../MediaController/Utility/Hls';
import { HlsNativeStreamHandler } from '../../../MediaController/Video';
import { MediaControllerController } from './MediaControllerController';

export class HlsController extends MediaControllerController {
    type = 'HLS';
    #url: string;

    constructor(wrapperElement: HTMLDivElement, url: string) {
        const handler = createHlsStreamHandler({
            continuousPlayback: true,
            muted: false,
            videoUrl: url,
        });
        super(wrapperElement, handler);
        this.#url = url;

        if (handler instanceof HlsNativeStreamHandler) {
            this.type = 'HLS_NATIVE';
        }
    }

    async canBePlayed(): Promise<boolean> {
        const isSupported: boolean = Hls.isSupported();
        const isValidStream: boolean = await isHlsStreamValid(this.#url);
        return isSupported && isValidStream;
    }
}
